export const iconFontAwesomeAnimalsKiwiBird = (
	<i className="fa-solid fa-kiwi-bird"></i>
);
